var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agree-doc",domProps:{"innerHTML":_vm._s(_vm.licenseAgreement)}})
}
var staticRenderFns = []

export { render, staticRenderFns }